import { defineComponent as _defineComponent } from 'vue'
import useIcons from '@/composables/useIcons'

  interface Brand {
    icon: string
    alt: string
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'BrandBar',
  setup(__props) {

  const { concordiaLogo, postbankLogo, dieBayerischeLogo, zurichLogo } = useIcons()

  const brands: Brand[] = [
    { icon: concordiaLogo.value, alt: 'Concordia' },
    { icon: postbankLogo.value, alt: 'Postbank' },
    { icon: dieBayerischeLogo.value, alt: 'Die Bayerische' },
    { icon: zurichLogo.value, alt: 'Zurich' },
  ]

return { __sfc: true,concordiaLogo, postbankLogo, dieBayerischeLogo, zurichLogo, brands, useIcons }
}

})